<template>
  <div class="scenario-container">
    <!-- <img
      v-for="(layer, deep) in scenario"
      :key="deep"
      :src="$imageUrl(layer.layer, `scenarios/${layer.scenario}`)"
      contain
      :class="className(deep)"
    /> -->
      <!-- :key="deep" -->
    <img
      :src="$imageUrl(scenario, `scenarios`)"
      contain
    />
      <!-- :class="className(deep)" -->
  </div>
</template>

<style scoped>
.scenario-container {
  height: 200px;
  margin: 0 auto;
  max-width: 375px;
  overflow: hidden;
  position: relative;
  width: 100%;
  ;
}
  .scenario-container > * {
    left: 0;
    max-width: 375px;
    position: absolute;
    top: 0;
    /*transform: translate(0);*/
    width: 100%;
  }
</style>

<script>
export default {
  name: 'QuizScenario.vue',
  props: {
    scenario: {
      type: [Array, String],
      default: () => [],
    },
  },
  data: () => ({
    runIddle: false,
    // This will be a param
    // scenario: [
    //   {
    //     layer: '0',
    //     scenario: '01',
    //     enter: 'fromTop',
    //     iddle: '',
    //   },
    //   {
    //     layer: '1',
    //     scenario: '01',
    //     enter: 'fromRight',
    //     iddle: 'shake-chunk shake-constant',
    //   },
    //   {
    //     layer: '2',
    //     scenario: '01',
    //     enter: 'fromLeft',
    //     iddle: '',
    //   },
    // ],
  }),
  methods: {
    className(i) {
      let name = this.scenario[i].enter;
      if (this.runIddle) {
        name += ` ${this.scenario[i].iddle}`;
      }

      return name;
    },
  },
  created() {
    setTimeout(() => {
      this.runIddle = true;
    }, 1000);
  },
};
</script>
